import { render, staticRenderFns } from "./version.vue?vue&type=template&id=31b36114&scoped=true&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./version.vue?vue&type=style&index=1&id=31b36114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b36114",
  null
  
)

export default component.exports